<template>
  <div class="time-view">
    <image-toolbox :selectedNum="selectedNum" :loadedAllImageNum="allImages.length" :selectedImages="selectedImages"
    v-on:closeSelected="closeSelected"
    v-on:deleteSelectedImages="deleteSelectedImages"
    v-on:selectLoaded="selectLoadedImage"></image-toolbox>
    <div class="view-content time-view-content">
      <div class="fixed-line clearfix" :class="{'show': filesArr.length > 0}" @mouseenter="showFixedCheckbox" @mouseleave="hideFixedCheckbox" >
        <div class="fixed-left">
          <div class="date">
            <span v-if="lang === 'en'"><span class="year">{{year}} </span>{{month}} {{day}}</span>
            <span v-else-if="lang === 'ru_RU'"><span class="year">{{year}} </span>{{month}} {{day}}</span>
            <span v-else><span class="year">{{year}}年</span>{{month}}月{{day}}日</span>
            <i class="icon-down-arrow"></i>
            <div class="date-list">
              <div class="date-li" v-if="lang === 'en'" v-for="(monthSumm, monthLiIndex) in monthList" :key="monthLiIndex" @click="jumpMonth(monthSumm.year, monthSumm.month)">{{monthSumm.localeMonthStr}} {{monthSumm.year}} ({{monthSumm.getCount()}})</div>
              <div class="date-li" v-if="lang === 'ru_RU'" v-for="(monthSumm, monthLiIndex) in monthList" :key="monthLiIndex" @click="jumpMonth(monthSumm.year, monthSumm.month)">{{monthSumm.localeMonthStr}} {{monthSumm.year}} ({{monthSumm.getCount()}})</div>
              <div class="date-li" v-if="lang !== 'en' && lang !== 'ru_RU'" v-for="(monthSumm, monthLiIndex) in monthList" :key="monthLiIndex" @click="jumpMonth(monthSumm.year, monthSumm.month)">{{monthSumm.year}}.{{monthSumm.localeMonthStr}} ({{monthSumm.getCount()}})</div>
            </div>
          </div>
          <div class="checkbox" :class="{'active': activeGroup(activeGroupIndex), 'selected' : selectedGroup(activeGroupIndex)}" @click="selectedAll(activeGroupIndex)"></div>
        </div>
        <div class="total-item">{{$t('list.thisday')}} {{thisDayCounts}} {{$t('list.items')}}/{{$t('list.total')}} {{totalFilesCount}} {{$t('list.items')}}</div>
      </div>
      <div v-bind:id="filesItem.dataStr" class="time-item-wrap clearfix" :class="{'active': filesItem.active, 'selected': filesItem.selected}" v-for="(filesItem,groupIndex) in filesArr" :key="groupIndex" @mouseover="showGroupCheckbox(groupIndex)"  @mouseout="hideGroupCheckbox(groupIndex)">
        <div class="time-item-date">
          <div class="date">
            <span v-if="lang === 'en'">{{filesItem.localeMonthStr}} {{filesItem.day}} {{filesItem.year}}</span>
            <span v-else-if="lang === 'ru_RU'">{{filesItem.localeMonthStr}} {{filesItem.day}} {{filesItem.year}}</span>
            <span v-else>
              <span class="year">{{filesItem.year}}年</span>{{filesItem.month}}月{{filesItem.day}}日
            </span>
          </div>
          <div class="checkbox" @click="selectedAll(groupIndex)"></div>
        </div>
        <div class="view-item time-item-file" :class="{'active': file.active, 'selected': file.selected}" v-for="(file,fileIndex) in filesItem.files" :key="file.id" @mouseenter="showFileCheckbox(groupIndex, fileIndex)" @mouseleave="hideFileCheckbox(groupIndex, fileIndex)">
          <div class="img-wrap" :style="{width: file.showWidth + 'px', height: file.showHeight + 'px'}">
            <img v-lazy="file.middle" alt="" @click="showImage(groupIndex, fileIndex)">
            <div class="checkbox" @click="singleFileClick(groupIndex, fileIndex)"></div>
          </div>
        </div>
      </div>
      <div class="no-file" v-if="showNoFile">
        <div class="no-file-main">
          <img src="../../assets/images/no_file.png" alt="">
          <div>{{$t('list.noFile')}}</div>
        </div>
      </div>
    </div>
    <div class="data-loading" :class="{'show': dataLoading}">
      <div class="container">
        <loading :loading="true"></loading>
        <span class="data-loading-text">{{$t('list.loading')}}</span>
      </div>
    </div>
    <!-- 图片预览播放器 -->
    <player :show="playerShow" :images="swiperImages" :allIndex="playerStartIndex" @closeButtonClick="closeImagePlayer" v-on:pageModeChanged="imageModeChanged(arguments[0], arguments[1])" v-on:reloadPlayerData="resetPlayerData(arguments[0])" ref="player"></player>
    <processing :processing="processing"></processing>
  </div>
</template>
<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import FilesGroup from 'common/model/FilesGroup'
import Image from 'common/model/Image'
import MonthSummary from 'common/model/MonthSummary'
import Player from './Player'
import ImageToolbox from './ImageToolbox'
import Loading from '../Loading'
import Processing from './Processing'
export default {
  name: 'timeView',
  components: {
    Player,
    ImageToolbox,
    Loading,
    Processing
  },
  data () {
    return {
      filesArr: [], // 按时间分组的数据
      allImages: [], // 所有的图片数据（排序后的）
      swiperImages: [], // 用户图片播放器的文件数组
      swiperIndex: 0, // 图片预览器中的数据index
      playerStartIndex: 0, // 图片预览器中的数组在所有图片数据中的开始位置
      playerShow: false, // 图片预览播放器是否显示
      showIndex: 0, // 显示图片在所有的文件数组中的index
      selectedNum: 0, // 选中的图片数量
      activeGroupIndex: 0, // 当前处于active状态的group index
      dataLoading: false, // 数据是否在加载
      monthList: [], // 月份汇总数组
      lastSeqNum: 0, // 最后图片的seqNum
      showNoFile: false, // 是否显示没有文件的提示
      totalFilesCount: 0, // 全部图片的数量
      hasGetAllData: false, // 是否获取到了全部的数据
      processing: true,
      lang: ''
    }
  },
  beforeRouteLeave (to, from, next) { // 页面离开
    next()
  },
  created () {
    if (this.$i18n.locale === 'en') {
      this.lang = 'en'
    }
    if (this.$i18n.locale === 'ru_RU') {
      this.lang = 'ru_RU'
    }
    var obj = this
    this.$Lazyload.$on('loaded', function (listener) {
      for (var i = 0; i < obj.allImages.length; i++) {
        var image = obj.allImages[i]
        if (image.isSameMiddle(listener.src)) {
          image.computeShowSize(listener.naturalWidth, listener.naturalHeight)
          break
        }
      }
    })
    // 添加延迟0.1s的原因：当切换‘时间’和‘分类’时，页面会重新请求数据，此时性能较差，影响‘时间’和‘分类’下面的滚动条动画的流畅，
    // 所以延迟0.1s动画差不多执行完毕，再请求数据，动画就不会卡顿
    setTimeout(function () {
      obj.requestFileList()
      obj.requestDateList()
    }, 100)
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    player () {
      return this.$refs.player
    },
    year () {
      if (this.filesArr.length > 0) {
        return this.filesArr[this.activeGroupIndex].year
      } else {
        return ''
      }
    },
    month () {
      if (this.filesArr.length > 0) {
        var month = this.filesArr[this.activeGroupIndex].month
        return Config.monthFn(this.lang, month)
      } else {
        return ''
      }
    },
    day () {
      if (this.filesArr.length > 0) {
        return this.filesArr[this.activeGroupIndex].day
      } else {
        return ''
      }
    },
    selectedImages () {
      var selectedImages = []
      for (var i = 0; i < this.allImages.length; i++) {
        if (this.allImages[i].selected) {
          selectedImages.push(this.allImages[i])
        }
      }
      return selectedImages
    },
    thisDayCounts () {
      if (this.filesArr.length === 0) {
        return 0
      } else {
        return this.filesArr[this.activeGroupIndex].files.length
      }
    }
  },
  methods: {
    activeGroup: function (index) {
      if (this.filesArr[index]) {
        return this.filesArr[index].active
      } else {
        return false
      }
    },
    selectedGroup: function (index) {
      if (this.filesArr[index]) {
        return this.filesArr[index].selected
      } else {
        return false
      }
    },
    selectedAll: function (index) {
      this.filesArr[index].selected = !this.filesArr[index].selected
      this.filesArr[index].selectAll(this.filesArr[index].selected)
      var selectCount = 0
      for (var j = this.filesArr.length - 1; j >= 0; j--) {
        selectCount += this.filesArr[j].selectedCounts()
      }
      this.selectedNum = selectCount
    },
    selectLoadedImage: function () {
      var selectCount = 0
      for (var i = 0; i < this.filesArr.length; i++) {
        // this.selectedAll(i)
        this.filesArr[i].selected = true
        this.filesArr[i].selectAll(true)
        selectCount += this.filesArr[i].files.length
      }
      this.selectedNum = selectCount
    },
    closeSelected: function () {
      this.selectedNum = 0
      for (var i = this.filesArr.length - 1; i >= 0; i--) {
        this.filesArr[i].selected = false
        this.filesArr[i].selectAll(false)
      }
    },
    singleFileClick: function (index, i) {
      this.filesArr[index].files[i].selected = !this.filesArr[index].files[i].selected
      var selectCount = 0
      for (var j = this.filesArr.length - 1; j >= 0; j--) {
        selectCount += this.filesArr[j].selectedCounts()
      }
      this.selectedNum = selectCount
    },
    withOutLogin: function () {
      this.$router.push('/')
    },
    exit: function () {
    },
    handleScroll: function (event) {
      // console.log(event)
      if (this.playerShow) {
        event = event || window.event
        if (event.preventDefault) {
          // Firefox
          event.preventDefault()
          event.stopPropagation()
        } else {
          // IE
          event.cancelBubble = true
          event.returnValue = false
        }
        event.preventDefault()
        return false
      }
      var t = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      var timeItemWrap = document.getElementsByClassName('time-item-wrap')
      for (var i = 0; i < timeItemWrap.length; i++) {
        var height1 = timeItemWrap[i].offsetTop - 55 // 55 每个group的padding值
        var height2 = height1 + timeItemWrap[i].offsetHeight
        if (t >= height1 && t < height2) {
          this.activeGroupIndex = i
        }
      }
      // 如果页面滑到了最低端，加载更多数据
      if (t >= document.body.scrollHeight - window.screen.height - 5) {
        this.loadingAfterFileList()
      }
    },
    requestFileList: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/file/time/day/50?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.processing = false
          this.assembleImageList(response.body)
          if (this.filesArr.length <= 0) {
            this.showNoFile = true
          }
        }
      })
    },
    requestDateList: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/file/summary/time?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.monthList = []
          var yearGroup = response.body
          var count = 0
          for (var i = 0; i < yearGroup.length; i++) {
            var yearObj = yearGroup[i]
            var monthLiYear = yearObj.year
            for (var k = yearObj.summary.length - 1; k >= 0; k--) {
              var monthSumm = new MonthSummary()
              monthSumm.year = monthLiYear
              monthSumm.month = yearObj.summary[k].month
              monthSumm.localeMonthStr = Config.monthFn(this.lang, yearObj.summary[k].month)
              monthSumm.count = yearObj.summary[k].counts
              count += yearObj.summary[k].counts
              this.monthList.push(monthSumm)
            }
          }
          // 时间进行排序
          for (var m = 0; m < this.monthList.length; m++) {
            for (var n = m + 1; n < this.monthList.length; n++) {
              if (this.monthList[m].dateStr < this.monthList[n].dateStr) {
                var temp = this.monthList[n]
                this.monthList[n] = this.monthList[m]
                this.monthList[m] = temp
              }
            }
          }
          this.totalFilesCount = count
        }
      })
    },
    loadingAfterFileList: function () {
      if (this.dataLoading || this.hasGetAllData) return
      if (this.filesArr.length > 0) {
        this.dataLoading = true
        HttpClient.getData(Config.APP_HOST + '/v1/file/time/afterday/' + this.lastSeqNum + '/50/?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
          if (response.code === Config.R_CODE.SUCCESS) {
            this.dataLoading = false
            if (response.body.length === 0) {
              this.hasGetAllData = true
              this.$toasted.show(this.$t('list.loaded'), {
                position: 'bottom-center'
              })
              return
            }
            this.assembleImageList(response.body)
          }
        })
      }
    },
    assembleImageList: function (respImageList) {
      // 对图片进行分组
      for (var i = 0; i < respImageList.length; i++) {
        var fileJson = respImageList[i]
        var image = new Image()
        image.loadData(fileJson)
        var dateGroup = this.findDateGroup(image.date)
        if (dateGroup === null) {
          dateGroup = new FilesGroup()
          dateGroup.dateStr = image.date
          this.filesArr.push(dateGroup)
        }
        dateGroup.appendImage(image)
        // 记录最后一条数据
        if (i === respImageList.length - 1) {
          this.lastSeqNum = image.seqNum
        }
      }
      // 把分组后的图片合并到一维数组中
      var images = []
      for (var index = 0; index < this.filesArr.length; index++) {
        var groupImages = this.filesArr[index]
        images = images.concat(groupImages.files)
      }
      this.allImages = images
    },
    findDateGroup: function (date) {
      var matched = null
      for (var i = this.filesArr.length - 1; i >= 0; i--) {
        var filesItem = this.filesArr[i]
        if (filesItem.isSameDay(date)) {
          matched = filesItem
        }
      }
      return matched
    },
    showFixedCheckbox: function () {
      this.filesArr[this.activeGroupIndex].active = true
    },
    hideFixedCheckbox: function () {
      this.filesArr[this.activeGroupIndex].active = false
    },
    showGroupCheckbox: function (index) {
      this.filesArr[index].active = true
    },
    hideGroupCheckbox: function (index) {
      this.filesArr[index].active = false
    },
    showFileCheckbox: function (index, i) {
      this.filesArr[index].files[i].active = true
      this.filesArr[index].active = true
    },
    hideFileCheckbox: function (index, i) {
      this.filesArr[index].files[i].active = false
      this.filesArr[index].active = false
    },
    deleteSelectedImages: function () {
      this.selectedNum = 0
      for (var i = 0; i < this.filesArr.length; i++) {
        for (var k = 0; k < this.filesArr[i].files.length; k++) {
          if (this.filesArr[i].files[k].selected) {
            this.filesArr[i].files.splice(k, 1)
            k--
          }
        }
        if (this.filesArr[i].files.length === 0) {
          this.filesArr.splice(i, 1)
        }
      }
      // 把分组后的图片合并到一维数组中
      var images = []
      for (var index = 0; index < this.filesArr.length; index++) {
        var groupImages = this.filesArr[index]
        images = images.concat(groupImages.files)
      }
      this.allImages = images
      if (this.filesArr.length === 0) {
        this.requestFileList()
      }
      this.requestDateList()
      this.$emit('refreshUsage')
    },
    // 打开图片预览
    showImage: function (groupIndex, index) {
      // console.log(groupIndex, index)
      if (this.selectedNum > 0) {
        this.singleFileClick(groupIndex, index)
        return
      }
      this.playerShow = true
      var allIndex = 0
      for (var i = 0; i < this.filesArr.length; i++) {
        if (i === groupIndex) {
          allIndex += index
        } else if (i < groupIndex) {
          allIndex += this.filesArr[i].files.length
        } else {
          break
        }
      }
      this.showIndex = allIndex
      this.setImagePlayerData(this.showIndex)
    },
    closeImagePlayer: function (index) {
      this.playerShow = false
    },
    resetPlayerData: function (playerIndex) {
      var showIndex = this.playerStartIndex + playerIndex
      if (showIndex === this.allImages.length - 2) {
        this.player.cancelReload()
        return
      }
      this.setImagePlayerData(showIndex)
    },
    setImagePlayerData: function (showIndex) {
      // console.log(showIndex)
      // 获取图片预览详情页的数据
      var playCounts = 7
      this.playerStartIndex = showIndex - playCounts
      this.swiperIndex = showIndex - this.playerStartIndex
      if (this.playerStartIndex < 0) {
        this.swiperIndex = this.swiperIndex + this.playerStartIndex
        this.playerStartIndex = 0
      }
      this.swiperImages = this.allImages.slice(this.playerStartIndex, this.playerStartIndex + playCounts * 2 + 1)
      // console.log('this.playerStartIndex', this.playerStartIndex)
      // console.log('this.swiperIndex', this.swiperIndex)
      this.player.showImage(this.swiperIndex)
    },
    imageModeChanged: function (index, resultData) {
      var count = 0
      this.showIndex = index
      for (var i = 0; i < this.filesArr.length; i++) {
        if (this.filesArr[i].isSameDay(this.allImages[index].date)) {
          for (var j = 0; j < this.filesArr[i].files.length; j++) {
            if (this.filesArr[i].files[j] === this.allImages[index]) {
              if (resultData.length > 1) { // 如果为分页的数据，找到位置进行插入
                var newObj = this.allImages[index].copyObj()
                newObj.loadPageModeResult(resultData[1])
                this.filesArr[i].files.splice(j + 1, 0, newObj)
                this.allImages.splice(index + 1, 0, newObj)
                break
              }
            } else if (this.filesArr[i].files[j].name === this.allImages[index].name) {
              this.filesArr[i].files.splice(j, 1)
              this.allImages.splice(count, 1)
              if (count < index) {
                this.showIndex = count
              }
              break
            }
            count++
          }
          break
        } else {
          count += this.filesArr[i].files.length
        }
      }
      this.setImagePlayerData(this.showIndex)
      this.requestDateList()
    },
    jumpMonth: function (year, month) {
      // console.log(year, month)
      var monthDay = this.findMonthDataFromFileGroup(year, month)
      if (monthDay === null) {
        this.processing = true
        HttpClient.getData(Config.APP_HOST + '/v1/file/time/between/' + year + '/' + month + '/' + this.lastSeqNum + '/?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
          this.processing = false
          if (response.code === Config.R_CODE.SUCCESS) {
            this.assembleImageList(response.body)
            // 数据渲染完毕后进行滚动
            this.$nextTick(function () {
              var monthDay = this.findMonthDataFromFileGroup(year, month)
              var findDay = monthDay.dataStr
              this.scrollToDay(findDay)
            })
          }
        })
      } else {
        var findDay = monthDay.dataStr
        this.scrollToDay(findDay)
      }
    },
    scrollToDay: function (findDay) {
      var options = {
        offset: -50,
        force: true,
        cancelable: true
      }
      this.$scrollTo('[id="' + findDay + '"]', 500, options)
    },
    findMonthDataFromFileGroup: function (year, month) {
      var find = null
      for (var i = 0; i < this.filesArr.length; i++) {
        if (this.filesArr[i].year === year && this.filesArr[i].month === month) {
          find = this.filesArr[i]
          break
        }
      }
      return find
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.view-content
  &.time-view-content
    padding 30px 0 50px 30px
    .fixed-line
      display none
      &.show
        display block
      .fixed-left
        .date
          width 120px
          position relative
          cursor pointer
          text-align left
          .year
            font-size 16px
          .icon-down-arrow
            vertical-align text-bottom
            font-size 12px
          .date-list
            min-width 100px
            position absolute
            top 30px
            right 0
            padding 6px 0px
            background-color #fff
            font-size 12px
            border 1px solid #f2f2f2
            border-radius 4px
            display none
            .date-li
              display block
              height 30px
              line-height 30px
              padding-left 13px
              color #ababab
              cursor pointer
              box-sizing border-box
              &:hover
                color #3d3d3d
          &:hover
            .date-list
              display block
        .checkbox
          top 10px
          left 177px
          &.active
            display block
          &.selected
            display block
            background-image url('../../assets/images/checkbox_click.png')
    .time-item-wrap
      &.active
        .time-item-date
          .checkbox
            display block
      &.selected
        .time-item-date
          .checkbox
            display block
            background-image url('../../assets/images/checkbox_click.png')
      .time-item-date
        width 100%
        height 40px
        line-height 40px
        text-align left
        font-size 12px
        position relative
        /*background-color pink*/
        margin-top 20px
        .date
          width 180px
          height 40px
          .year
            font-size 16px
        .checkbox
          width 20px
          height 20px
          background-image url('../../assets/images/checkbox_hover.png')
          background-repeat no-repeat
          background-size 100%
          position absolute
          top 10px
          left 147px
          cursor pointer
          display none
      .time-item-file
        .img-wrap
          width 100%
          height 100%
          max-width 100%
          max-height 100%
          position absolute
          margin auto
          top 0
          left 0
          right 0
          bottom 0
          cursor pointer
          transition all .3s ease
          img
            max-width 100%
            max-height 100%
          .checkbox
            right 6px
            bottom 7px
        &.active
          .img-wrap
            top -8px
            img
              box-shadow rgba(169, 169, 169, 0.64) 0px 6px 30px 5px
            .checkbox
              display block
        &.selected
          .img-wrap
            .checkbox
              background-image url('../../assets/images/checkbox_click.png')
              display block
</style>



// WEBPACK FOOTER //
// src/components/Et/TimeView.vue